import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Col,
  Layout,
  Select,
  Checkbox,
  Space,
  Switch,
  Radio,
  Upload,
  Tag,
  Spin,
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  DeleteFilled,
  SettingOutlined,
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
  EditFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import textToVoice from "controllers/textToVoice";
import textToFile from "controllers/textToFile";
import s3Controller from "controllers/s3Controller";
import textToFile2 from "controllers/textToFile2";
import s3Controller2 from "controllers/s3Controller2";
import dayjs from "dayjs";
import Excel from "exceljs";
import fileSaver from "file-saver";
import readExcel from "read-excel-file";
import OpenAI from "openai";

import translateFuntion from "./controller/translateFuntion";
import SentenceProgress from "./SentenceProgress";
import sentenceZipUpload from "controllers/sentenceZipUpload";
import UploadProgressBar from "./UploadProgressBar";
import SentenceInterpretationInput from "./SentenceInterpretationInput"
import translateGPT from "./controller/translateGPT";
import SentenceImageRight from "./SentenceImageRight";
import createImagePromptGPT from "./controller/createImagePromptGPT";
import createImageGPT from "./controller/createImageGPT";
import SentenceImageSub from "./SentenceImageSub"
import SentenceImageCreate from "./SentenceImageCreate";

const backend = process.env.REACT_APP_BACKEND;
const meaningPrompt = process.env.REACT_APP_MEANING_PROMPT
const backgroundPrompt = process.env.REACT_APP_BACKGROUND_PROMPT

const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true 
})

function SentenceInterpretation({filter, filterHandler}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reRender, setReRender] = useState(false);
  const [groups, setGroups] = useState([]);
  const [courses, setCourses] = useState([]);
  const [stages, setStages] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [units, setUnits] = useState([]);
  const [subUnits, setSubUnits] = useState([]);
  const [sentencePatterns, setSentencePatterns] = useState([]);
  const [tenses, setTenses] = useState([]);
  const [constituentColor, setConstituentColor] = useState({});
  const [languages, setLanguages] = useState([]);
  const [morphemeAuth, setMorphemeAuth] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState({
    value: "L0010",
    label: "한국어",
  });

  const [confirmLoading, setConfirmLoading] = useState(false)
  const [preSourceDataKor, setPreSourceDataKor] = useState([]);
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [upLoadPopup, setUpLoadPopup] = useState(false);
  const [downLoadPopup, setDownLoadPopup] = useState(false);
  const [upload, setUpload] = useState([false, ""]);
  const [download, setDownload] = useState([false, ""]);
  const compareRef = useRef(null);
  const stopRef = useRef(false);
  const formRef = useRef(null);
  const rightFormRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [fileList, setFileList] = useState([]); //업로드시 선택된 파일 리스트
  const [imageSetting, setImageSetting] = useState(false)
  const [imageConfig, setImageConfig] = useState({})
  const [createImageProgress, setCreateImageProgress] = useState([0,0])
  const [imageLoading, setImageLoading] = useState(false)
  const [loadingAll, setLoadingAll] = useState(false)

  const [rightBoxLoading, setRightBoxLoading] = useState(false)
  const [rightBox, setRightBox] = useState([false, {}]);
  const [rightBoxPreNext, setRightBoxPreNext] = useState([false, false]);
  const [rowIndex, setRowIndex] = useState(null);
  const [gptVersion, setGptVersion] = useState("gpt-4")
  // const [rightBoxImage, setRightBoxImage] = useState([])

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [10, 50, 100, 200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    filters: {
      group: filter.group,
      course: filter.course,
      stage: filter.stage,
      chapter: filter.chapter,
      unit: filter.unit,
      subUnit: filter.subUnit,
      sentenceStatus: filter.sentenceStatus,
      searchFilter: "",
      language: "L0010",
    },
  });

  const [uploadProgress, setUploadProgress] = useState([false, 0, 0,""])
  const [translateProgress, setTranslateProgress] = useState([false, 0, 0]);
  const [createFileProgress, setCreateFileProgress] = useState([false, 0, 0]);
  const [startEnd, setStartEnd] = useState([0, 0]);
  const [isStop, setStop] = useState({
    translateVoice: false,
    morpheme: false,
    phonetic: false,
    tts10Stop: false,
  });

  const morphemeOption = [2, 500];
  const speechOption = [3, 1000];
  const phoneticOption = [2, 2000];

  const sentenceUploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]); // 여러개 할 경우 앞에 ...fileList를 붙임
      return false;
    },
    fileList,
  };

  const columns = [
    Table.SELECTION_COLUMN,
    {
      title: "문장코드",
      dataIndex: "id",
      key: "id",
      width: "100px",
    },
    {
      title: "문장상태",
      dataIndex: "imageStatus2",
      key: "imageStatus2",
      width: "100px",
      render: (_, record) => (
        <Switch
          className="sentenceSwitch"
          checkedChildren="편집"
          unCheckedChildren="운영"
          // disabled={record.imageCount === record.imageEditCount}
          // checked={record.imageCount !== record.imageEditCount ? true : false}
          disabled={_ !== "Y"}
          checked={_ === "Y" ? true : false}
          onChange={(value,e)=>changeStatus(value,e,record)}
        ></Switch>
      ),
    },
    {
      title: "서브유닛 코드",
      dataIndex: "ContentSubUnit_code",
      key: "ContentSubUnit_code",
      width: "130px",
    },
    {
      title: "문장번호",
      dataIndex: "seq",
      key: "seq",
      width: "100px",
    },
    {
      title: "영어문장",
      dataIndex: "sentence_text",
      key: "sentence_text",
      width: "300px",
    },
    {
      title: "의미 프롬프트",
      dataIndex:"",
      key:"",
      width: "110px",
      render: (_,record) => record.meaning_prompt ? <CheckOutlined/> : null
    },
    {
      title: "프롬프트 생성",
      dataIndex:"",
      key:"",
      width: "110px",
      render: (_,record)=>{
        const prompt = meaningPrompt.replace(/{}|{ }/gi,record.sentence_text)
        // const prompt = `Create a prompt for Dall E 3 to generate an image describing the sentence "${record.sentence_text}". Your prompt should be written to help viewers better understand the meaning of the sentence. Make sure to include the sentence in your prompt.`
        return(
          <SentenceImageSub
          record = {record}
          subUnit = {tableParams.filters.subUnit}
          prompt = {prompt}
          endpoint = {"meaning_prompt"}
          reRenderHandler = {reRenderHandler}
          imageConfig={imageConfig}
          ></SentenceImageSub>
          )
        }
      },
      {
        title: "배경 프롬프트",
        dataIndex:"",
        key:"",
        width: "110px",
        render: (_,record) => record.background_prompt ? <CheckOutlined/> : null
      },
      {
        title: "프롬프트 생성",
        dataIndex:"",
        key:"",
        width: "110px",
        render: (_,record)=>{
        const prompt = backgroundPrompt.replace(/{}|{ }/gi,record.sentence_text)
        // const prompt = `Create a prompt for Dall E 3 to generate a background image that helps viewers understand the meaning of "${record.sentence_text}". Make sure to include the sentence in your prompt.`
        return(
          <SentenceImageSub
            record = {record}
            subUnit = {tableParams.filters.subUnit}
            prompt = {prompt}
            endpoint = {"background_prompt"}
            reRenderHandler = {reRenderHandler}
            imageConfig={imageConfig}
          ></SentenceImageSub>
        )
      }
    },
    {
      title: "이미지 수(운영)",
      dataIndex:"imageCount",
      key:"imageCount",
      width: "120px",
      render:(_) => <span>{_}</span>
    },
    {
      title: "이미지 수(편집)",
      dataIndex:"imageEditCount",
      key:"imageEditCount",
      width: "120px",
      render:(_) => <span>{_}</span>
    },
    {
      title: "이미지 처리",
      dataIndex:"",
      key:"",
      width: "110px",
      render: (_,record)=>{
        const prompt = record.meaning_prompt+record.background_prompt
        return(
          <SentenceImageCreate
            record = {record}
            subUnit = {tableParams.filters.subUnit}
            prompt = {prompt}
            endpoint = {"images"}
            imageCreateHandler = {imageCreateHandler}
            imageConfig={imageConfig}
          ></SentenceImageCreate>
        )
      }
    },
    // {
    //   title: "파일명",
    //   dataIndex:"",
    //   key:"",
    //   width: "110px",
    // },
    {}
  ];

  const loadingHandler = (boolean) =>{
    setLoadingAll(boolean)
  }

  const reRenderHandler = (record) => {
    const instance = sourceDataKor.slice()
    instance[record.num].meaning_prompt = record.meaning_prompt
    instance[record.num].background_prompt = record.background_prompt
    instance[record.num].final_prompt = record.final_prompt
    instance[record.num].ContentSettingSentenceDALLE_id= record.ContentSettingSentenceDALLE_id
    // console.log(instance[record.num])
    setSourceDataKor(instance)
    if(rightBox[0]) {
      setRightBox([true,instance[rowIndex]])
    }
  }

  const imageCreateHandler = (num, method) => {
    const instance = sourceDataKor.slice()
    if(method === "create") {
      instance[num].imageEditCount ++
      
      if(instance[num].imageEditCount === instance[num].imageCount) {
        instance[num].imageStatus2 = "N"
      } else {
        instance[num].imageStatus2 = "Y"
      }
    } else {
      instance[num].imageEditCount = null
      instance[num].imageCount = null
      instance[num].imageStatus2 = "N"
    }
    setSourceDataKor(instance)
    if(rightBox[0]) {
      setRightBox([true,instance[rowIndex]])
    }
  }

  const imageDeleteHandler = (num, count, editCount, imageStatus) => {
    const instance = sourceDataKor.slice()
    instance[num].imageCount = count || null
    instance[num].imageEditCount = editCount || null
    instance[num].imageStatus2 = imageStatus

    setSourceDataKor(instance)
  }

  const orderChangeHandler = (num, imageStatus) => {
    const instance = sourceDataKor.slice()
    instance[num].imageStatus2 = imageStatus

    setSourceDataKor(instance)
  }

  const changeStatus = (value,e,record) => {
    e.stopPropagation();
    axios.put(`${backend}/contents/content_sentence/image_ai/images/status`,{ContentSettingSentenceDALLE_id:record.ContentSettingSentenceDALLE_id})
    .then(res=>{
      const instance = sourceDataKor.slice()
      instance[record.num].imageStatus2 = !value
      instance[record.num].imageCount = instance[record.num].imageEditCount
      setSourceDataKor(instance)
    })
    .catch(err=>{
      console.log(err)
    })
  }

  const changeStatusAll = () => {
    const selectedDalleKey = selectedRows.filter(el=>el.imageStatus2 === "Y" && el.ContentSettingSentenceDALLE_id).map(el=>el.ContentSettingSentenceDALLE_id)
    const selectedRowNum = selectedRows.filter(el=>el.imageStatus2 === "Y" && el.ContentSettingSentenceDALLE_id).map(el=>el.num)
    
    axios.put(`${backend}/contents/content_sentence/image_ai/images/status`,{ContentSettingSentenceDALLE_id:selectedDalleKey})
    .then(res=>{
      const instance = sourceDataKor.slice()
      selectedRowNum.forEach(el=>{
        instance[el].imageStatus2 = "N"
        instance[el].imageCount = instance[el].imageEditCount
      })
      setSourceDataKor(instance)
    })
    .catch(err=>{
      console.log(err)
    })
  }
  
  const deleteAll = () => {
    const selected = selectedRows.filter(el=>el.imageCount || el.imageEditCount)
    const selectedDalleKey = selected.map(el=>el.ContentSettingSentenceDALLE_id)
    const selectedRowNum = selected.map(el=>el.num)
    if(selectedDalleKey.length === 0) {
      Modal.info({
        title: "이미지 선택",
        content: "삭제할 이미지가 없습니다.",
        okText:"확인"
      })
    }

    axios.post(`${backend}/contents/content_sentence/image_ai/images`,{ContentSettingSentenceDALLE_id:selectedDalleKey})
      .then(res=>{

        const files = res.data.data.map(el=>{
          return {Key: "AIimages/"+el.sentence_image_filename}
        })
        s3Controller.s3DeleteFiles(files,(err,data)=>{
          if (err) console.log(err)
        })

        const instance = sourceDataKor.slice()
        selectedRowNum.forEach(el=>{
          instance[el].imageCount = null
          instance[el].imageEditCount = null
          instance[el].imageStatus2 = "N"
        })
        setSourceDataKor(instance)
      })
      .catch(err=>{
        console.log(err)
      })
  }

  const createImage = () => {
    const record = rightBox[1]
    // console.log(record)

    if(record.final_prompt) {
      // setRightBoxLoading(true)
      loadingHandler(true)
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const fileName = `image_${record.id}_${currentVer}.jpeg`;
      const size = imageConfig.image_size

      createImageGPT(fileName, size,  record.final_prompt)
      .then(imageFile=>{
        s3Controller.s3Upload(imageFile,"AIimages",(err, data)=>{
          //업로드가 완료되었을 경우 콜백
          if (err) {
            Modal.error({
              title:"에러",
              okText:"확인",
              content:"s3에 업로드 중 에러가 발생해서 생성을 취소했습니다."
            })
          } else {
            const newKey = data.Key
            const newFile = data.Key.split("/")[1]
            axios.post(`${backend}/contents/content_sentence/image_ai/images/${record.id}/${record.ContentSettingSentenceDALLE_id}`,
            {newFile, size})
            .then(res=>{
              imageCreateHandler(record.num, "create")
            })
            .catch(err=>{
              console.log(err)
              s3Controller.s3DeleteFile(newKey, (err, data) => {
                if (err) console.log(err);
              });
              Modal.error({
                title:"에러",
                okText:"확인",
                content:"서버 에러가 발생해서 이미지를 저장하지 못했습니다."
              })
            })
          }
        })
        
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"AI 에러가 발생해서 문장을 생성하지 못했습니다."
        })
      })
      .finally(()=>{
        // setRightBoxLoading(false)
        loadingHandler(false)
      })
    } else {
      Modal.info({
        title: "프롬프트문장 필요",
        content: "이미지를 생성하기 위해서는 프롬프트 문장이 필요합니다. 먼저 프로프트 문장을 생성하고 저장하세요.",
        okText:"확인"
      })
    }
  }

  const imageSettingOKHandler = () => {
    const value = formRef.current.getFieldsValue()
    
    axios.put(`${backend}/contents/content_sentence/image_ai/setting`,{value})
    .then(res=>{
      setImageSetting(false)
      setImageConfig(value)
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title: "저장에러",
        content: "에러가 발생하여 저장에 실패했습니다.",
        okText: "확인"
      })
    })
  }

  const createMeaningPromptAll = async () => {
    let count=0
    if(selectedRows.length) {
      setImageLoading(true)
      setCreateImageProgress([selectedRows.length, 0])
    } else {
      Modal.info({
        title: "문장선택 필요",
        content: "이미지를 생성할 문장이 없습니다. 이미지를 생성하기 위해서는 저장된 프롬프트가 필요합니다.",
        oktext:"확인"
      })
    }

    const waitF = async (sec) => {
      return new Promise((resolve) => setTimeout(resolve, sec));
    }
    const checkCondition = async (i) => {
      if(count === i) {
        console.log(`${count}개 완료 후 재요청 중`)
        return true
      }
    }

    loop:
    for (let i = 0; i<selectedRows.length; i++) {

      const sentence_text = selectedRows[i].sentence_text
      const prompt = meaningPrompt.replace(/{}|{ }/gi,sentence_text)
      // const prompt = `Create a prompt for Dall E 3 to generate an image describing the sentence "${sentence_text}". Your prompt should be written to help viewers better understand the meaning of the sentence. Make sure to include the sentence in your prompt.`

      if(i !== 0 && i % 10 === 0) {
        let isContinue = false
        // console.log("일시정지", isContinue)
        while (!isContinue) {
          await waitF(1000)
          isContinue = await checkCondition(i)
          // console.log(isContinue)
          
          //강제로 종료할 경우 루프를 종료시킨다. 이미 보낸 요청은 중지할 수 없다.
          if(stopRef.current === true) {
            stopRef.current = false
            setCreateImageProgress([0,0])
            setImageLoading(false)

            break loop
          }
        }
      }
      //대기상태가 아닌 루프가 돌고 있는 상태에서도 중지가 되어야 한다.
      if(stopRef.current === true) {
        stopRef.current = false
        setCreateImageProgress([0,0])
        setImageLoading(false)

        break loop
      }

      createImagePromptGPT(prompt, imageConfig.gpt_model)
      .then(newPrompt=>{
        let onlyPrompt = newPrompt
        if(newPrompt[0] === `"`) {
          onlyPrompt = newPrompt.slice(1,-1)
        }
        const id = selectedRows[i].id
        const ContentSettingSentenceDALLE_id = selectedRows[i].ContentSettingSentenceDALLE_id
        axios.put(`${backend}/contents/content_sentence/image_ai/meaning_prompt/${id}/${ContentSettingSentenceDALLE_id}`,
        {newPrompt:onlyPrompt})
        .then(res=>{
          count ++
          const instance = sourceDataKor.slice()
          instance[selectedRows[i].num].meaning_prompt = newPrompt
          if(res.data.data) {
            instance[selectedRows[i].num].ContentSettingSentenceDALLE_id = res.data.data
          }
          setSourceDataKor(instance)
          if(count === selectedRows.length) {
            setCreateImageProgress([0,0])
            setImageLoading(false)
          } else {
            setCreateImageProgress([selectedRows.length, count])
          }
        })
        .catch(err=>{
          console.log(err)
          count++
          if(count === selectedRows.length) {
            setImageLoading(false)
            setCreateImageProgress([0,0])
          } else {
            setCreateImageProgress([selectedRows.length, count])
          }
        })
      })
      .catch(err=>{
        console.log(err)
        if(count === selectedRows.length) {
          setImageLoading(false)
          setCreateImageProgress([0,0])
        } else {
          setCreateImageProgress([selectedRows.length, count])
        }
      })
    }
    
  }
  
  const createBackgroundPromptAll = async() => {
    let count = 0
    if(selectedRows.length) {
      setImageLoading(true)
      setCreateImageProgress([selectedRows.length, 0])
    } else {
      Modal.info({
        title: "문장선택 필요",
        content: "이미지를 생성할 문장이 없습니다. 이미지를 생성하기 위해서는 저장된 프롬프트가 필요합니다.",
        oktext:"확인"
      })
    }

    const waitF = async (sec) => {
      return new Promise((resolve) => setTimeout(resolve, sec));
    }
    const checkCondition = async (i) => {
      if(count === i) {
        console.log(`${count}개 완료 후 재요청 중`)
        return true
      }
    }

    loop:
    for (let i = 0; i<selectedRows.length; i++) {
      const sentence_text = selectedRows[i].sentence_text
      const prompt = backgroundPrompt.replace(/{}|{ }/gi,sentence_text)
      // const prompt = `Create a prompt for Dall E 3 to generate a background image that helps viewers understand the meaning of "${sentence_text}". Make sure to include the sentence in your prompt.`

      if(i !== 0 && i % 10 === 0) {
        let isContinue = false
        // console.log("일시정지", isContinue)
        while (!isContinue) {
          await waitF(1000)
          isContinue = await checkCondition(i)
          // console.log(isContinue)
          
          //강제로 종료할 경우 루프를 종료시킨다. 이미 보낸 요청은 중지할 수 없다.
          if(stopRef.current === true) {
            stopRef.current = false
            setCreateImageProgress([0,0])
            setImageLoading(false)

            break loop
          }
        }
      }
      //대기상태가 아닌 루프가 돌고 있는 상태에서도 중지가 되어야 한다.
      if(stopRef.current === true) {
        stopRef.current = false
        setCreateImageProgress([0,0])
        setImageLoading(false)

        break loop
      }

      createImagePromptGPT(prompt, imageConfig.gpt_model)
      .then(newPrompt=>{
        let onlyPrompt = newPrompt
        if(newPrompt[0] === `"`) {
          onlyPrompt = newPrompt.slice(1,-1)
        }
        const id = selectedRows[i].id
        const ContentSettingSentenceDALLE_id = selectedRows[i].ContentSettingSentenceDALLE_id
        axios.put(`${backend}/contents/content_sentence/image_ai/background_prompt/${id}/${ContentSettingSentenceDALLE_id}`,
        {newPrompt:onlyPrompt})
        .then(res=>{
          count ++
          const instance = sourceDataKor.slice()
          instance[selectedRows[i].num].background_prompt = newPrompt
          if(res.data.data) {
            instance[selectedRows[i].num].ContentSettingSentenceDALLE_id = res.data.data
          }
          setSourceDataKor(instance)
          if(count === selectedRows.length) {
            setCreateImageProgress([0,0])
            setImageLoading(false)
          } else {
            setCreateImageProgress([selectedRows.length, count])
          }
        })
        .catch(err=>{
          console.log(err)
          count++
          if(count === selectedRows.length) {
            setCreateImageProgress([0,0])
            setImageLoading(false)
          } else {
            setCreateImageProgress([selectedRows.length, count])
          }
        })
      })
      .catch(err=>{
        console.log(err)
        if(count === selectedRows.length) {
          setCreateImageProgress([0,0])
          setImageLoading(false)
        } else {
          setCreateImageProgress([selectedRows.length, count])
        }
      })
    }
  }

  const createImageAll = async () => {
    // console.log(selectedRows)
    let count = 0
    const filteredSelectedRows = selectedRows.filter(el=>el.final_prompt)
    if(filteredSelectedRows.length) {
      setCreateImageProgress([filteredSelectedRows.length, 0])
      setImageLoading(true)
    } else {
      Modal.info({
        title: "문장선택 필요",
        content: "이미지를 생성할 문장이 없습니다. 이미지를 생성하기 위해서는 저장된 프롬프트가 필요합니다.",
        oktext:"확인"
      })
    }
    const waitF = async (sec) => {
      return new Promise((resolve) => setTimeout(resolve, sec));
    }
    const checkCondition = async (i) => {
      if(count === i) {
        console.log("일시대기", count)
        return true
      }
    }

    loop:
    for (let i = 0; i<filteredSelectedRows.length; i++) {
      // console.log("i:", i)
     
      const row = filteredSelectedRows[i]
      // const prompt = `${row.meaning_prompt} ${row.background_prompt}`
      const prompt = row.final_prompt
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const fileName = `image_${row.id}_${currentVer}.jpeg`;
      const size = imageConfig.image_size

      if(i !== 0 && i % 3 === 0) {
        let isContinue = false
        // console.log("일시정지", isContinue)
        while (!isContinue) {
          await waitF(1000)
          isContinue = await checkCondition(i)
          // console.log(isContinue)
          
          //강제로 종료할 경우 루프를 종료시킨다. 이미 보낸 요청은 중지할 수 없다.
          if(stopRef.current === true) {
            stopRef.current = false
            setCreateImageProgress([0,0])
            setImageLoading(false)

            break loop
          }
        }
      }
      //대기상태가 아닌 루프가 돌고 있는 상태에서도 중지가 되어야 한다.
      if(stopRef.current === true) {
        stopRef.current = false
        setCreateImageProgress([0,0])
        setImageLoading(false)

        break loop
      }

      createImageGPT(fileName, size,  prompt)
      .then(imageFile=>{
        if (imageFile === false) {
          count++
          // console.log("gpt에러", count)
          if(count === filteredSelectedRows.length) {
            setCreateImageProgress([0,0])
            setImageLoading(false)
          } else {
            setCreateImageProgress([filteredSelectedRows.length, count])
          }
        } else {
          s3Controller.s3Upload(imageFile,"AIimages",(err, data)=>{
            //업로드가 완료되었을 경우 콜백
            if (err) {
              count++
              // console.log("aws에러", count)
              if(count === filteredSelectedRows.length) {
                setCreateImageProgress([0,0])
                setImageLoading(false)
              } else {
                setCreateImageProgress([filteredSelectedRows.length, count])
              }
            } else {
              const newKey = data.Key
              const newFile = data.Key.split("/")[1]
              axios.post(`${backend}/contents/content_sentence/image_ai/images/${row.id}/${row.ContentSettingSentenceDALLE_id}`,
              {newFile, size})
              .then(res=>{
                const instance = sourceDataKor.slice()
                instance[row.num].imageEditCount++
                if(instance[row.num].imageStatus2 === "N") {
                  instance[row.num].imageStatus2 = "Y"
                }
                setSourceDataKor(instance)
                count++
                // console.log("정상", count)
                if(count === filteredSelectedRows.length) {
                  setCreateImageProgress([0,0])
                  setImageLoading(false)
                } else {
                  setCreateImageProgress([filteredSelectedRows.length, count])
                }
              })
              .catch(err=>{
                console.log(err)
                s3Controller.s3DeleteFile(newKey, (err, data) => {
                  if (err) console.log(err);
                });
                count++
                // console.log("서버에러", count)
                if(count === filteredSelectedRows.length) {
                  setCreateImageProgress([0,0])
                  setImageLoading(false)
                } else {
                  setCreateImageProgress([filteredSelectedRows.length, count])
                }
              })
            }
          })
        }     
      })
      await waitF(1000)
    }
  }


  





  const textChangeHandler = (rowData, isChange) => {
    // console.log(isChange)
    if(isChange) {
      singleChange(rowData.translate_text, rowData, "translate_text");
    }
    const instance = sourceDataKor.slice()
    instance[rowData.num].translate_text = rowData.translate_text
    instance[rowData.num].SystemSettingLanguage_code =
      currentLanguage.value;
    setSourceDataKor(instance);
  }

  const getSourceData = (data) => {
    const total = data.data[1][0]["FOUND_ROWS()"];
    if(total === 0 && rightBox[0]) {
      setRightBox([false, {}])
    }
    const sourceData = data.data[0].map((el, idx) => {
      el.num = idx;
      return el;
    });
    setSourceDataKor(sourceData);
    setPreSourceDataKor(JSON.parse(JSON.stringify(sourceData))); // db에러 시 되돌리기 위한 소스
    setSelectedRows([]);
    setSelectedKeys([]);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: total, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  };

  const groupFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        group: value,
        course: "all",
        stage: "all",
        chapter: "all",
        unit: "all",
        subUnit: "all",
      },
    });
    filterHandler({
      group: value,
      course: "all",
      stage: "all",
      chapter: "all",
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const courseFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        course: value,
        stage: "all",
        chapter: "all",
        unit: "all",
        subUnit: "all",
      },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: value,
      stage: "all",
      chapter: "all",
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const stageFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        stage: value,
        chapter: "all",
        unit: "all",
        subUnit: "all",
      },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: value,
      chapter: "all",
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const chapterFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: {
        ...tableParams.filters,
        chapter: value,
        unit: "all",
        subUnit: "all",
      },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: value,
      unit: "all",
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const unitFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, unit: value, subUnit: "all" },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: tableParams.filters.chapter,
      unit: value,
      subUnit: "all",
      sentenceStatus: "all",
    })
  };

  const subUnitFilter = (value) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
      filters: { ...tableParams.filters, subUnit: value },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: tableParams.filters.chapter,
      unit: tableParams.filters.unit,
      subUnit: value,
      sentenceStatus: "all",
    })
  };

  const sentenceStatusFilter = (value) => {
    setTableParams({
      ...tableParams,
      filters: { ...tableParams.filters, sentenceStatus: value },
      pagination: { ...tableParams.pagination, current: 1 },
    });
    filterHandler({
      group: tableParams.filters.group,
      course: tableParams.filters.course,
      stage: tableParams.filters.stage,
      chapter: tableParams.filters.chapter,
      unit: tableParams.filters.unit,
      subUnit: tableParams.filters.subUnit,
      sentenceStatus: value,
    })
  };

  const languageFilter = (value) => {
    const currentL = languages.filter((el) => el.value === value);
    setCurrentLanguage(currentL[0]);
    setTableParams({
      ...tableParams,
      filters: { ...tableParams.filters, language: value },
      pagination: { ...tableParams.pagination, current: 1 },
    });
  };

  const onSearch = (value) => {
    setTableParams({
      ...tableParams,
      filters: { ...tableParams.filters, searchFilter: value },
      pagination: { ...tableParams.pagination, current: 1 },
    });
    setRightBox([false, {}]);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      ...tableParams,
      pagination,
    });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setSourceDataKor([]);
    }
    setRightBox([false, {}]);
    setRowIndex(null);
    // if (rightBox[0]) {
    //   setRowIndex(0);
    //   setRightBox([true,sourceDataKor[0]])
    // }
  };

  function sleep(sec) {
    return new Promise((resolve) => setTimeout(resolve, sec));
  }

  const listenTranslateVoice = async (record) => {
    const { voice_file_speaker } = currentLanguage;
    if (record.translate_text === null || record.translate_text === "") {
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "음성 듣기를 실행할 영어문장이 없습니다.",
      });
    } else {
      const text = record.translate_text;
      const speaker = voice_file_speaker;
      const speedNum = 1.0;
      const name = `<voice name="${speaker}">`;
      const speed = `<prosody rate="${speedNum}">`;

      textToVoice(text, name, speed, (err, data) => {
        Modal.error({
          title: "음성파일 듣기 에러",
          okText: "확인",
          content:
            "Azure SDK에서 에러가 발생하여 정상적으로 듣기를 실행하지 못했습니다.",
        });
      });
    }
  };

  const listenFileVoice = (_, record) => {
    const bucket = "https://englemining-admin.s3.ap-northeast-2.amazonaws.com/";
    const prefix = `translate/${record.ContentChapter_code}/${currentLanguage.locale}`;
    const audioUrl = bucket + prefix + "/" + _;

    const audio = new Audio(audioUrl);
    audio.play()
    .catch(err=>{
      console.dir(err)
      Modal.error({
        title: "재생에러",
        content: err.message,
        oktext:"확인"
      })
    })
  };

  const createVoiceFile = async (record) => {
    const { voice_file_speaker, locale } = currentLanguage;
    if (record.translate_text === null || record.translate_text === "") {
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "음성파일을 생성할 영어문장이 없습니다.",
      });
    } else {
      const originInstance = JSON.parse(JSON.stringify(sourceDataKor));
      const instance = sourceDataKor.slice();

      const speedNum = 1.0;
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

      const fileName = `translate_${record.id}_${locale}_${currentVer}.mp3`;
      const text = record.translate_text;
      const name = `<voice name="${voice_file_speaker}">`;
      const speed = `<prosody rate="${speedNum}">`;

      textToFile(
        text,
        name,
        speed,
        fileName,
        `translate/${record.ContentChapter_code}/${locale}`,
        (err, data) => {
          if (err) {
            Modal.error({
              title: "업로드 에러",
              okText: "확인",
              content:
                "업로드 중 에러가 발생하였습니다. 재시도 하시고 에러가 계속될 경우 관리자에게 문의하세요.",
            });
          } else {
            // console.log(data);
            const newKey = data.Key;
            const prefix = data.Key.split("_").slice(0, -1).join("_");

            const newFileName =
              data.key.split("/")[data.key.split("/").length - 1];

            instance[record.num].translate_voice_filename = newFileName;
            instance[record.num].SystemSettingLanguage_code =
              currentLanguage.value;

            const compare = translateFuntion.compareData(instance[record.num]);

            if (compare) {
              instance[record.num].sentenceStatus = "N";
            } else {
              instance[record.num].sentenceStatus = "Y";
            }
            setSourceDataKor(instance);

            axios
              .post(
                `${backend}/contents/content_sentence/sentence_interpretation/changeRecord`,
                {
                  table: "ContentSentenceEditDetail",
                  field: "translate_voice_filename",
                  value: [newFileName],
                  condition: [record.id],
                  record: [record],
                  SystemSettingLanguage_code: currentLanguage.value,
                }
              )
              .then((data) => {
                // console.log("c");
                // 기존에 등록된 파일 중 동일id에 해당하는 파일을 지워주는 로직
                s3Controller.s3List(prefix, (err, result) => {
                  if (err) {
                    console.log(err);
                  } else {
                    const files = result.Contents.reduce((acc, cur) => {
                      if (cur.Key === newKey) {
                        return acc;
                      } else {
                        acc.push({ Key: cur.Key });
                        return acc;
                      }
                    }, []);
                    if (files.length !== 0) {
                      s3Controller.s3DeleteFiles(files, (err, data) => {
                        if (err) console.log(err);
                      });
                    }
                  }
                });
                // console.log("d");
              })
              .catch((err) => {
                console.log(err);
                s3Controller.s3DeleteFile(newKey, (err, data) => {
                  if (err) console.log(err);
                });
                Modal.error({
                  afterClose: () => {
                    setSourceDataKor(originInstance);
                  },
                  title: "서버에러",
                  okText: "확인",
                  content:
                    "서버에 에러가 발생하여 파일을 생성하지 못했습니다. 다시 시도하여 주시고 에러가 지속된다면 관리자에게 문의해주세요.",
                });
              });
          }
        }
      );
    }
  };

  const createVoiceFileAll = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "문장성분 분석",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      try {
        let continueCreateFile = true;
        const max = selectedRows.length;
        setCreateFileProgress([true, 0, max]);

        const { voice_file_speaker, locale } = currentLanguage;

        for (let i = 0; i < selectedRows.length; i++) {
          if (!continueCreateFile) {
            break;
          }
          if (
            selectedRows[i].translate_text === null ||
            selectedRows[i].translate_text === ""
          ) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setCreateFileProgress([true, i + 1, max]);
              continue;
            } else {
              setCreateFileProgress([false, 0, 0]);
              break;
            }
          }

          const originInstance = JSON.parse(JSON.stringify(sourceDataKor));
          const instance = sourceDataKor.slice();
          const record = selectedRows[i];
          const speedNum = 1.0;
          const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

          const fileName = `translate_${record.id}_${locale}_${currentVer}.mp3`;
          const text = record.translate_text;
          const name = `<voice name="${voice_file_speaker}">`;
          const speed = `<prosody rate="${speedNum}">`;
          const data = await textToFile2(
            text,
            name,
            speed,
            fileName,
            `translate/${record.ContentChapter_code}/${locale}`
          );
          if (!data.Key) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setCreateFileProgress([true, i + 1, max]);
              continue;
            } else {
              setCreateFileProgress([false, 0, 0]);
              break;
            }
          }
          const newKey = data.Key;
          const prefix = data.Key.split("_").slice(0, -1).join("_");

          const newFileName =
            data.key.split("/")[data.key.split("/").length - 1];

          instance[record.num].translate_voice_filename = newFileName;
          instance[record.num].SystemSettingLanguage_code =
            currentLanguage.value;

          const compare = translateFuntion.compareData(instance[record.num]);

          if (compare) {
            instance[record.num].sentenceStatus = "N";
          } else {
            instance[record.num].sentenceStatus = "Y";
          }
          setSourceDataKor(instance);
          try {
            const axiosResult = await axios.post(
              `${backend}/contents/content_sentence/sentence_interpretation/changeRecord`,
              {
                table: "ContentSentenceEditDetail",
                field: "translate_voice_filename",
                value: [newFileName],
                condition: [record.id],
                record: [record],
                SystemSettingLanguage_code: currentLanguage.value,
              }
            );
            if (axiosResult.status === 200) {
              const result = await s3Controller2.s3List(prefix);

              const files = result.Contents.reduce((acc, cur) => {
                if (cur.Key === newKey) {
                  return acc;
                } else {
                  acc.push({ Key: cur.Key });
                  return acc;
                }
              }, []);
              if (files.length !== 0) {
                const result = await s3Controller2.s3DeleteFiles(files);
              }
              setCreateFileProgress([true, i + 1, max]);
              if (isStop.createFile) {
                Modal.info({
                  title: "작업 중지",
                  okText: "확인",
                  content: `문장코드 ${selectedRows[i].id}까지 진행 후 작업을 중지했습니다.`,
                  afterClose: () => {
                    isStop.createFile = false;
                  },
                });
                break;
              }
              sleep(200);
            }
          } catch (err) {
            console.log(err);
            const result = await s3Controller2.s3DeleteFile(newKey);
            const modalF = () => {
              return new Promise((resolve, reject) => {
                instance[record.num].translate_voice_filename =
                  originInstance[record.num].translate_voice_filename;
                const compare = translateFuntion.compareData(
                  instance[record.num]
                );

                if (compare) {
                  instance[record.num].sentenceStatus = "N";
                } else {
                  instance[record.num].sentenceStatus = "Y";
                }
                setSourceDataKor(originInstance);
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    instance[record.num].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            await modalF().then((data) => {
              continueCreateFile = data;
              if (data) {
                setCreateFileProgress([true, i + 1, max]);
              } else {
                setCreateFileProgress([false, 0, 0]);
              }
            });
          }
        }
        await sleep(1000);
        setCreateFileProgress([false, 0, 0]);
      } catch (err) {
        console.log(err);
        setCreateFileProgress([false, 0, 0]);
        // if (err.response.status === 401) {
        //   Modal.error({
        //     title: "인증 에러",
        //     okText: "확인",
        //     content: "인증이 만료되었습니다. 다시 로그인해주세요.",
        //     afterClose: () => {
        //       navigate("/auth");
        //     },
        //   });
        // }
      }
    }
  };

  const translate = (record) => {
    if (!record.sentence_text) {
      Modal.info({
        title: "문장해석",
        okText: "확인",
        content: "선택된 문장이 비어있습니다.",
      });
    } else {
      const instance = sourceDataKor.slice();
      const { locale, value } = currentLanguage;
      // console.log(currentLanguage)

      axios
        .post(
          `${backend}/contents/content_sentence/sentence_interpretation/translate`,
          {
            target: locale,
            lang: value,
            record,
          },
          { withCredentials: true }
        )
        .then((data) => {
          // console.log(data);
          instance[record.num].translate_text = data.data.data;
          instance[record.num].SystemSettingLanguage_code =
            currentLanguage.value;
          // setSourceDataKor(instance);

          const compare = translateFuntion.compareData(instance[record.num]);
          if (compare) {
            instance[record.num].sentenceStatus = "N";
            instance[record.num].existId = instance[record.num].id;
          } else {
            instance[record.num].sentenceStatus = "Y";
            instance[record.num].existId = instance[record.num].id;
          }
          setSourceDataKor(instance);
          // singleChange(data.data, record, "translate_text");
        })
        .catch((err) => {
          console.log(err);
          Modal.error({
            title: "해석 에러",
            okText: "확인",
            content: "네이버해석 중 문제가 발생하였습니다.",
          });
        });
    }
  };
  
  const translateAll = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "문장 해석",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      let continueTranslate = true;
      const { locale, value } = currentLanguage;
      const max = selectedRows.length;
      setTranslateProgress([true, 0, max]);

      for (let i = 0; i < selectedRows.length; i++) {
        try {
          if (!continueTranslate) {
            break;
          }
          if (
            selectedRows[i].sentence_text === null ||
            selectedRows[i].sentence_text === ""
          ) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "문장에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장이 비어있습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
          if (isStop.translateVoice) {
            Modal.info({
              title: "작업 중지",
              okText: "확인",
              content: `문장코드 ${
                selectedRows[i - 1].id
              }까지 진행 후 작업을 중지했습니다.`,
              afterClose: () => {
                isStop.translateVoice = false;
              },
            });
            break;
          }

          const instance = sourceDataKor.slice();
          const record = selectedRows[i];
          const translateResult = await axios.post(
            `${backend}/contents/content_sentence/sentence_interpretation/translate`,
            {
              target: locale,
              lang: value,
              record,
            },
            { withCredentials: true }
          );
          if (translateResult.status === 200) {
            instance[record.num].translate_text = translateResult.data.data;
            instance[record.num].SystemSettingLanguage_code =
              currentLanguage.value;
            const compare = translateFuntion.compareData(instance[record.num]);

            if (compare) {
              instance[record.num].sentenceStatus = "N";
              instance[record.num].existId = instance[record.num].id;
            } else {
              instance[record.num].sentenceStatus = "Y";
              instance[record.num].existId = instance[record.num].id;
            }
            setTranslateProgress([true, i + 1, max]);
            setSourceDataKor(instance);
          } else {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
        } catch (err) {
          console.log(err);
          if (err.response.status === 401) {
            Modal.error({
              title: "인증 에러",
              okText: "확인",
              content: "인증이 만료되었습니다. 다시 로그인해주세요.",
              afterClose: () => {
                navigate("/auth");
              },
            });
          } else {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
        }
      }
      await sleep(1000);
      setTranslateProgress([false, 0, 0]);
    }
  };

  const translateAIAll = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "문장 해석",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      let continueTranslate = true;
      isStop.translateVoice = false;
      const { locale, value } = currentLanguage;
      const max = selectedRows.length;
      setTranslateProgress([true, 0, max]);

      for (let i = 0; i < selectedRows.length; i++) {
        try {
          if (!continueTranslate) {
            break;
          }
          if (
            selectedRows[i].sentence_text === null ||
            selectedRows[i].sentence_text === ""
          ) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "문장에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장이 비어있습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
          if (isStop.translateVoice) {
            Modal.info({
              title: "작업 중지",
              okText: "확인",
              content: `문장코드 ${
                selectedRows[i - 1].id
              }까지 진행 후 작업을 중지했습니다.`,
              afterClose: () => {
                isStop.translateVoice = false;
              },
            });
            break;
          }

          const instance = sourceDataKor.slice();
          const record = selectedRows[i];
          // const translateResult = await axios.post(
          //   `${backend}/contents/content_sentence/sentence_interpretation/translate`,
          //   {
          //     target: locale,
          //     lang: value,
          //     record,
          //   },
          //   { withCredentials: true }
          // );
          const prompt =
          `
          translate each sentences into Korean. Make sure to translate every subject for example "나는" for I, "당신은" for you, "그는" for he, "그녀는" for she and on, End a sentence in "입니다/합니다/합니까".
          - ${record.sentence_text}
          `
          const translateResult = await translateGPT(prompt, gptVersion)
          
          if (isStop.translateVoice) {
            break;
          }
          if (translateResult) {
            singleChange(translateResult[0].korean, record, "translate_text");
            instance[record.num].translate_text = translateResult[0].korean;
            instance[record.num].SystemSettingLanguage_code =
              currentLanguage.value;
            const compare = translateFuntion.compareData(instance[record.num]);

            if (compare) {
              instance[record.num].sentenceStatus = "N";
              instance[record.num].existId = instance[record.num].id;
            } else {
              instance[record.num].sentenceStatus = "Y";
              instance[record.num].existId = instance[record.num].id;
            }
            setTranslateProgress([true, i + 1, max]);
            setSourceDataKor(instance);
          } else {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
        } catch (err) {
          console.log(err);
          if (err.response.status === 401) {
            Modal.error({
              title: "인증 에러",
              okText: "확인",
              content: "인증이 만료되었습니다. 다시 로그인해주세요.",
              afterClose: () => {
                navigate("/auth");
              },
            });
          } else {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
        }
      }
      // await sleep(1000);
      setTranslateProgress([false, 0, 0]);
    }
  }

  //루프로 기다리지 않고 sdk이용하는 방법
  const translateAIAll3 = async () => {
    if (selectedKeys.length === 0) {
      Modal.info({
        title: "문장 해석",
        okText: "확인",
        content: "선택된 문장이 없습니다.",
      });
    } else {
      let continueTranslate = true;
      isStop.translateVoice = false
      let now = 0
      let isStopFirst = true
      const max = selectedRows.length;
      setTranslateProgress([true, 0, max]);

      for (let i = 0; i < selectedRows.length; i++) {
        try {
          if (!continueTranslate) {
            break;
          }
          if (
            selectedRows[i].sentence_text === null ||
            selectedRows[i].sentence_text === ""
          ) {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "문장에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장이 비어있습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, i + 1, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
          if (isStop.translateVoice) {
            Modal.info({
              title: "작업 중지",
              okText: "확인",
              content: `문장코드 ${
                selectedRows[i - 1].id
              }까지 진행 후 작업을 중지했습니다.`,
              afterClose: () => {
                isStop.translateVoice = false;
              },
            });
            break;
          }

          const instance = sourceDataKor.slice();
          const record = selectedRows[i];
          // const translateResult = await axios.post(
          //   `${backend}/contents/content_sentence/sentence_interpretation/translate`,
          //   {
          //     target: locale,
          //     lang: value,
          //     record,
          //   },
          //   { withCredentials: true }
          // );
          const prompt =
          `
          translate each sentences into Korean. Make sure to translate every subject for example "나는" for I, "당신은" for you, "그는" for he, "그녀는" for she and on, End a sentence in "입니다/합니다/합니까".
          - ${record.sentence_text}
          `
          const translateResult = translateGPT(prompt, gptVersion)
          
          // if (translateResult) {
            translateResult
            .then(res=>{
              if(!isStop.translateVoice) {
                now ++
                singleChange(res[0].korean, record, "translate_text");
                instance[record.num].translate_text = res[0].korean;
                instance[record.num].SystemSettingLanguage_code =
                  currentLanguage.value;
                const compare = translateFuntion.compareData(instance[record.num]);
    
                if (compare) {
                  instance[record.num].sentenceStatus = "N";
                  instance[record.num].existId = instance[record.num].id;
                } else {
                  instance[record.num].sentenceStatus = "Y";
                  instance[record.num].existId = instance[record.num].id;
                }
                if(now === max) {
                  setTranslateProgress([false, 0, 0]);
                } else {
                  setTranslateProgress([true, now, max]);
                }
                setSourceDataKor(instance);
              }
            })
            .catch(err=>{
              console.log(record.id, err)
              if(now === max) {
                setTranslateProgress([false, 0, 0]);
              } else {
                setTranslateProgress([true, now, max]);
              }
            })
          // } else {
          //   const modalF = () => {
          //     return new Promise((resolve, reject) => {
          //       Modal.confirm({
          //         title: "서버에러",
          //         onCancel: () => {
          //           resolve(false);
          //         },
          //         onOk: () => {
          //           resolve(true);
          //         },
          //         okText: "계속",
          //         cancelText: "중지",
          //         content:
          //           selectedRows[i].id +
          //           "번 문장에서 에러가 발생하였습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
          //       });
          //     });
          //   };
          //   const modalResult = await modalF();
          //   if (modalResult) {
          //     setTranslateProgress([true, i + 1, max]);
          //     continue;
          //   } else {
          //     setTranslateProgress([false, 0, 0]);
          //     break;
          //   }
          // }
        } catch (err) {
          console.log(err);
          if (err.response.status === 401) {
            Modal.error({
              title: "인증 에러",
              okText: "확인",
              content: "인증이 만료되었습니다. 다시 로그인해주세요.",
              afterClose: () => {
                navigate("/auth");
              },
            });
          } else {
            const modalF = () => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "서버에러",
                  onCancel: () => {
                    resolve(false);
                  },
                  onOk: () => {
                    resolve(true);
                  },
                  okText: "계속",
                  cancelText: "중지",
                  content:
                    selectedRows[i].id +
                    "번 문장에서 에러가 발생하였습니다. 나머지 문장해석을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
                });
              });
            };
            const modalResult = await modalF();
            if (modalResult) {
              setTranslateProgress([true, now, max]);
              continue;
            } else {
              setTranslateProgress([false, 0, 0]);
              break;
            }
          }
        }
      }
      // await sleep(1000);
      // setTranslateProgress([false, 0, 0]);
    }
  }

  const singleChange = async (_, record, field) => {
    const instance = sourceDataKor.slice();
    const originInstance = JSON.parse(JSON.stringify(instance));
    try {
      // console.log(compareRef.current)
      const changeRecordResult = await axios.post(
        `${backend}/contents/content_sentence/sentence_interpretation/changeRecord`,
        {
          table: "ContentSentenceEditDetail",
          field: field,
          value: [_],
          condition: [record.id],
          record: [record],
          SystemSettingLanguage_code: currentLanguage.value,
        }
      );

      if (changeRecordResult.status === 200) {
        const compare = translateFuntion.compareData(record);
        if (compare) {
          instance[record.num].sentenceStatus = "N";
          instance[record.num].existId = record.id;
        } else {
          instance[record.num].sentenceStatus = "Y";
          instance[record.num].existId = record.id;
        }
        setSourceDataKor(instance);
        // setPreSourceDataKor(JSON.parse(JSON.stringify(instance)));
      }
    } catch (err) {
      console.log("에러", err);
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "서버에러가 발생하여 정상적으로 변경하지 못했습니다.",
        afterClose: () => {
          setSourceDataKor(originInstance);
        },
      });
    }
  };

  const UploadOkHandler = () => {
    // console.log(formRef.current.getFieldsValue());
    if(confirmLoading) {

      return
    }
    const chapter = tableParams.filters.chapter;
    const lang = formRef.current.getFieldValue("language");
    const locale = languages.filter((el) => el.value === lang)[0].locale;
    setConfirmLoading(true)

    if (chapter === "all") {
      Modal.error({
        title: "챕터선택 오류",
        content: "압축파일을 생성할 챕터가 선택되지 않았습니다.",
        okText: "확인",
        afterClose: () => {
          setConfirmLoading(false)
          setUpLoadPopup(false);
        },
      });
    } else {
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const prefix = `translate/${chapter}/${locale}`;
      const path = "voiceFiles/";
      const zipName = "translate" + "_" + chapter.toLowerCase() + "_" + locale;
      const callback = (err, data, fileName) => {
        if (err) {
          console.log(err);
          setConfirmLoading(false)
          setUploadProgress([false,0,0,""])
          Modal.error({
            title: "에러",
            okText: "확인",
            content:
              `${fileName ? fileName+" 파일에서" : null} 에러가 발생하여 정상적으로 압축파일을 생성하지 못하였습니다. 다시 시도하시고 계속 에러가 날 경우 관리자에게 문의하세요.`,
          });
        } else {
          const file = data.key.split("/")[data.key.split("/").length - 1];
          const path = data.key.replace(`/${file}`, "");
          Modal.success({
            title: "업로드 성공",
            okText: "확인",
            content: `AWS S3 ${data.Bucket}버킷의 ${path}경로에 ${file}를 등록하였습니다.`,
          });
          setUploadProgress([false,0,0,""])
          setConfirmLoading(false)
          setUpLoadPopup(false);
        }
      };
      const progress = (total,current,fileName) => {
        // console.log(current,"/",total)
        setUploadProgress([true,current,total,fileName])
      }

      sentenceZipUpload(prefix, path, zipName, callback,progress);
    }
  };

  const runningHandler = (record) => {
    let selected = [];
    if (record.id) {
      selected = [record];
    } else {
      selected = selectedRows.filter((el) => el.sentenceStatus === "Y");
    }

    // const selected = selectedRows.filter(el=>el.sentenceStatus === "Y")
    if (selected.length === 0) {
      Modal.info({
        title: "운영상태 변경확인",
        okText: "확인",
        content:
          "선택된 문장이 없거나 선택된 문장 중 편집모드인 문장이 없습니다.",
      });
    } else {
      Modal.confirm({
        style: { whiteSpace: "pre-line" },
        title: "운영상태 변경",
        content: `선택한 문장을 운영상태로 변경하시겠습니까 ?`,
        okText: "변경",
        cancelText: "취소",
        cancelButtonProps: { type: "primary" },
        okButtonProps: { type: "default" },
        onOk: async () => {
          try {
            const Result = await axios.post(
              `${backend}/contents/content_sentence/sentence_interpretation/running`,
              { selected }
            );

            if (Result.status === 200) {
              setReRender(!reRender);
              Modal.success({
                title: "변경 완료",
                okText: "확인",
                content: "정상적으로 변경되었습니다.",
              });
            }
          } catch (err) {
            console.log(err);
            Modal.error({
              title: "에러",
              okText: "확인",
              content: `서버에러가 발생하여 동기화하지 못했습니다.`,
            });
          }
        },
      });
    }
  };

  //------------------------------------
  //------------------------------------
  // 수동으로 변경했을때 로직에 대해서 전체적으로 다시 검토가 필요하다.

  const translateUploadHandler = () => {
    const uploadOption = formRef.current.getFieldValue("uploadOption");
    const fieldOption = upload[1];
    const languageOption = languages.filter(
      (el) => el.value === formRef.current.getFieldValue("language")
    )[0];
    const columnOption = fieldOption + "_" + languageOption.locale;

    const map = {
      id: "id",
    };
    map[columnOption] = fieldOption;

    readExcel(fileList[0], { map, includeNullValues: true })
      .then((data) => {
        // console.log(data)
        axios
          .post(
            `${backend}/contents/content_sentence/sentence_interpretation/upload_excel`,
            { data, uploadOption, languageOption }
          )
          .then((data) => {
            // console.log(data)
            if (data.status === 201) {
              return Modal.error({
                title: "파일컨텐츠 에러",
                okText: "확인",
                content:
                  "파일 컨텐츠의 id값 중 중복되는 값이 있습니다. 파일을 확인하세요.",
              });
            }
            Modal.success({
              title: "업로드 완료",
              okText: "확인",
              content: `총 ${data.data.data.all}건 중 업데이트 ${data.data.data.update}건, 신규생성 ${data.data.data.new}건 성공하였습니다.`,
              afterClose: () => {
                setReRender(!reRender);
                setUpload([false, ""]);
                setFileList([]);
              },
            });
          })
          .catch((err) => {
            console.log(err);
            if (err.response.status === 401) {
              navigate("/auth");
            }
            Modal.error({
              title: "서버 에러",
              okText: "확인",
              content: "에러가 발생하여 업로드에 실패하였습니다.",
            });
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const translateDownloadHandler = () => {
    if (tableParams.pagination.total === 0) {
      return Modal.error({
        title: "에러",
        okText: "확인",
        content: "다운로드 할 문장이 없습니다.",
      });
    }
    setLoading(true);
    const lan = formRef.current.getFieldValue("downOption");

    const languageOption = lan.map((el) => {
      const language = languages.filter((ele) => ele.value === el)[0];
      return language;
    });

    const fieldOption = download[1];
    axios
      .post(
        `${backend}/contents/content_sentence/sentence_interpretation/download_sentence`,
        {
          filter: tableParams.filters,
          languageOption,
          fieldOption,
        }
      )
      .then(async (data) => {
        // console.log(data);
        const { subUnit, unit, stage, group, course, chapter } =
          tableParams.filters;
        const filters = [subUnit, unit, chapter, stage, course, group];
        const lans = languageOption.reduce((acc, cur) => {
          return (acc = acc + cur.locale);
        }, "");

        const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
        let fileName = fieldOption + "_ALL_" + lans + "_" + currentVer;
        for (let i = 0; i < filters.length; i++) {
          if (filters[i] !== "all") {
            fileName =
              fieldOption + "_" + filters[i] + "_" + lans + "_" + currentVer;
            break;
          }
        }
        // console.log(fileName);

        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet("englemlining");
        worksheet.columns = Object.keys(data.data.data[0][0]).map((el) => {
          return { header: el, key: el };
        });
        worksheet.insertRows(2, data.data.data[0]);
        const buffer = await workbook.xlsx.writeBuffer();
        fileSaver(new Blob([buffer]), fileName + ".xlsx");
        setLoading(false);
        setDownload(false, "");
        Modal.success({
          title: "문장 다운로드",
          oktext: "확인",
          content: `${
            fieldOption === "translate_text" ? "해석자료" : "힌트자료"
          } ${
            data.data.data[1][0]["FOUND_ROWS()"]
          }개의 문장이 ${fileName}.xlsx라는 파일 이름으로 다운로드 되었습니다.`,
        });
      });
  };

  const onRow = (record, rowIdx) => {
    return {
      onClick: () => {
        const data = sourceDataKor;
        const maxNum = tableParams.pagination.total - 1;
        const plusNum =
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize;
        const idx = plusNum + rowIdx;

        if (data.length === 1 && tableParams.pagination.total === 1) {
          setRightBoxPreNext([true, true]);
        } else if (idx === 0) {
          setRightBoxPreNext([true, false]);
        } else if (idx === maxNum) {
          setRightBoxPreNext([false, true]);
        } else {
          setRightBoxPreNext([false, false]);
        }
        setRowIndex(rowIdx);
        // setCurLanguage(data[idx].SystemSettingLanguage_code);
        setRightBox([true, data[rowIdx]]);
        if (rightBox[0]) {
          // rightFormRef.current.setFieldsValue(data[rowIdx]);
        }
      },
    };
  };

  const resetValueRight = () => {
    // const nowNum = rightFormRef.current.getFieldValue(["num"]);
    // rightFormRef.current.setFieldsValue(sourceDataKor[nowNum]); // 리셋을 초기값으로 하지 않고 변경된 현재 데이터로 하기 위함
  };

  const preRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setRightBoxPreNext([false, false]);
    }
    if (preNum === 0) {
      setRightBoxPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    // setCurLanguage(data[preNum].SystemSettingLanguage_code);

    if (rightBox[0]) {
      if (rowIndex === 0) {
        // rightFormRef.current.setFieldValue("num", preNum - plusNum);
      } else {
        setRightBox([true, data[preNum - plusNum]]);
        // rightFormRef.current.resetFields();
        // rightFormRef.current.setFieldsValue(data[preNum - plusNum]);
      }
    }
  };

  const editOkHandlerRight = async () => {
    const instance = sourceDataKor.slice();
    const originInstance = JSON.parse(JSON.stringify(instance));
    try {
      // let newData = rightFormRef.current.getFieldsValue();
      let newData = ""
      instance[rowIndex].translate_text = newData.translate_text;
      instance[rowIndex].sentence_hint = newData.sentence_hint;
      instance[rowIndex].SystemSettingLanguage_code = currentLanguage.value;

      newData.SystemSettingLanguage_code = currentLanguage.value;
      const saveRightRecord = await axios.post(
        `${backend}/contents/content_sentence/sentence_interpretation/save_right`,
        {
          record: newData,
        }
      );
      if (saveRightRecord.status === 200) {
        const compare = translateFuntion.compareData(instance[rowIndex]);
        if (compare) {
          instance[rowIndex].sentenceStatus = "N";
          instance[rowIndex].existId = instance[rowIndex].id;
        } else {
          instance[rowIndex].sentenceStatus = "Y";
          instance[rowIndex].existId = instance[rowIndex].id;
        }
        setSourceDataKor(instance);
        Modal.success({
          title: "수정 완료",
          oktext: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      }
    } catch (err) {
      console.log("에러", err);
      Modal.error({
        title: "에러",
        okText: "확인",
        content: "서버에러가 발생하여 정상적으로 변경하지 못했습니다.",
        afterClose: () => {
          setSourceDataKor(originInstance);
        },
      });
    }
  };

  const nextRecordRight = () => {
    const data = sourceDataKor;
    const nowNum =
      rowIndex +
      (tableParams.pagination.current - 1) * tableParams.pagination.pageSize;
    const max = tableParams.pagination.total - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setRightBoxPreNext([false, false]);
    }
    if (nextNum === max) {
      setRightBoxPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);

    // setCurLanguage(data[nextNum].SystemSettingLanguage_code);
    if (rightBox[0]) {
      if (nextNum - plusNum === 0) {
        // rightFormRef.current.setFieldValue("num", nextNum - plusNum);
      } else {
        setRightBox([true, data[nextNum - plusNum]]);
        // rightFormRef.current.resetFields();
        // rightFormRef.current.setFieldsValue(data[nextNum - plusNum]);
      }
    }
  };

  const editCancelHandlerRight = () => {
    setRightBox([false, {}]);
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  };

  useEffect(()=>{
    if(languages.length) {
      const currentLang = languages.filter(
        (el) => el.value === tableParams.filters.language
      );
      setCurrentLanguage(currentLang[0])
    }
  },[languages])

  useEffect(() => {
    axios
      .get(`${backend}/contents/content_sentence/sentence_interpretation/group`)
      .then((data) => {
        const groupList = data.data.data[0].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const courseList = data.data.data[1].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const stageList = data.data.data[2].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const chapterList = data.data.data[3].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const unitList = data.data.data[4].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });
        const subUnitList = data.data.data[5].map((ele) => {
          ele.label = `${ele.value} ${ele.label}`;
          return ele;
        });

        setGroups(groupList);
        setCourses(courseList);
        setStages(stageList);
        setChapters(chapterList);
        setUnits(unitList);
        setSubUnits(subUnitList);
        setSentencePatterns(data.data.data[6]);
        setTenses(data.data.data[7]);
        setLanguages(data.data.data[8]);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/auth");
        }
        console.log(err);
      });
  }, []);

  useEffect(() => {
    // setLoading(true);
    setLoadingAll(true)
    const { current, pageSize } = tableParams.pagination;
    axios
      .post(
        `${backend}/contents/content_sentence/image_ai/list?current=${current}&pageSize=${pageSize}`,
        { filter: tableParams.filters }
      )
      .then((data) => {
        getSourceData(data);
        setImageConfig(data.data[2][0])
        // setLoading(false);
        setLoadingAll(false)
      })
      .catch((err) => {
        console.log(err);
        setLoadingAll(false)
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, 
  [
    JSON.stringify(tableParams.filters),
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    reRender
  ]);

  useEffect(() => {
    const lastPageSize =
      tableParams.pagination.total % tableParams.pagination.pageSize;
    const lastPageNum =
      parseInt(tableParams.pagination.total / tableParams.pagination.pageSize) +
      1;
    if (rightBox[0]) {
      if (tableParams.pagination.total === 1) {
        setRightBoxPreNext([true, true]);
      } else if (tableParams.pagination.current === 1 && rowIndex === 0) {
        setRightBoxPreNext([true, false]);
      } else if (
        sourceDataKor.length === 1 &&
        tableParams.pagination.current === lastPageNum
      ) {
        setRightBoxPreNext([false, true]);
      } else {
        setRightBoxPreNext([false, false]);
      }
      // setRowIndex(0)
      setRightBox([true, sourceDataKor[rowIndex]]);
      // rightFormRef.current.setFieldsValue(sourceDataKor[rowIndex]);
    } else {
      setRightBoxPreNext([false, false]);
    }
  }, [sourceDataKor]);

  // useEffect(()=>{
  //   if(rightBox[0]) {
  //     getImages(rowIndex)
  //   }
  // },[rowIndex])

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"99%" }}>
      <Spin spinning={loadingAll}>
      <Spin spinning={imageLoading} tip={
            <>
            <div>{`${createImageProgress[0]} 개 문장 중..${createImageProgress[1]}개 진행중...`}</div>
            <Button onClick={()=>{stopRef.current=true}}>중지</Button>
            </>
          }>
      <Modal
        destroyOnClose={true}
        open={imageSetting}
        title="설정"
        maskClosable={false}
        onCancel={() => {
          setImageSetting(false)
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                onClick={imageSettingOKHandler}
                icon={<CheckOutlined />}
                // disabled={fileList.length === 0}
              >
                확인
              </Button>
              <Button
                onClick={() => {
                  setImageSetting(false)
                }}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
          initialValues={imageConfig}
        >
          <Form.Item
            label = "생성할 이미지 사이즈"
            name = "image_size"
          >
            <Radio.Group>
              <Space>
                <Radio value={"1024x1024"}>1024x1024</Radio>
                <Radio value={"1024x1792"}>1024x1792</Radio>
                <Radio value={"1792x1024"}>1792x1024</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item 
            label = "생성할 이미지 갯수"
            name = "image_count"
          >
            <Input disabled></Input>
          </Form.Item>
          <Form.Item
            label = "프롬프트 생성 엔진"
            name = "gpt_model"
          >
            <Radio.Group>
              <Space>
                <Radio value={"gpt-4"}>GPT-4</Radio>
                <Radio value={"gpt-4-1106-preview"}>GPT-4 turbo</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label = "다운사이징 이미지 사이즈"
            name = "image_downsizing_size"
          >
            <Radio.Group>
              <Space>
                <Radio value={"512x512"}>512x512</Radio>
                <Radio value={"512x896"}>512x896</Radio>
                <Radio value={"896x512"}>896x512</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={download[0]}
        title={
          download[1] === "translate_text"
            ? "해석 데이터 다운로드"
            : "문장힌트 데이터 다운로드"
        }
        maskClosable={false}
        onCancel={() => {
          setDownload([false, ""]);
          setLoading(false);
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                onClick={translateDownloadHandler}
                icon={<DownloadOutlined />}
              >
                다운로드
              </Button>
              <Button
                onClick={() => {
                  setDownload([false, ""]);
                  setLoading(false);
                }}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={formRef}
          layout="vertical"
          initialValues={{ downOption: ["L0010"] }}
        >
          <Form.Item name="downOption" label="다운로드 할 언어">
            <Checkbox.Group
              options={[
                { ...languages[0], disabled: true },
                ...languages.slice(1),
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        destroyOnClose={true}
        open={upLoadPopup}
        title="음성파일 압축해서 서버로 업로드"
        maskClosable={false}
        onCancel={() => {
          if(!confirmLoading)
          setUpLoadPopup(false);
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              disabled={confirmLoading}
              onClick={() => {
                formRef.current.resetFields();
              }}
            >
              내용 초기화
            </Button>
            <span>
              <Button
                type="primary"
                key="submit"
                onClick={UploadOkHandler}
                icon={<UploadOutlined />}
                loading={confirmLoading}
              >
                업로드
              </Button>
              <Button
              key="cancel"
                disabled={confirmLoading}
                onClick={() => {
                  setUpLoadPopup(false);
                }}
                icon={<CloseOutlined />}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Spin spinning={confirmLoading}>
        <Form 
          ref={formRef}
          layout="vertical"
          initialValues={{ upLoadUnit: "chapter", language: "L0010" }}
        >
          <Form.Item name="upLoadUnit" label="압축 단위">
            <Radio.Group>
              <Radio value={"chapter"}>챕터</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="language" label="업로드 할 언어">
            <Select options={languages}></Select>
          </Form.Item>
        </Form>
        </Spin>
        {uploadProgress[0] ? <UploadProgressBar per={uploadProgress}></UploadProgressBar> : null}
      </Modal>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ minWidth: "100px", textAlign: "left" }}>문장 목록</span>
        <Space wrap>
          <Select
            options={[{ value: "all", label: "그룹: 전체" }, ...groups]}
            style={{ width: 200, textAlign: "left" }}
            defaultValue="all"
            value={tableParams.filters.group}
            onChange={groupFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "코스: 전체" },
              ...courses.filter(
                (el) =>
                  tableParams.filters.group === "all" ||
                  tableParams.filters.group === el.group_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.group === "all"}
            defaultValue="all"
            value={tableParams.filters.course}
            onChange={courseFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "스테이지: 전체" },
              ...stages.filter(
                (el) =>
                  tableParams.filters.course === "all" ||
                  tableParams.filters.course === el.course_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.course === "all"}
            defaultValue="all"
            value={tableParams.filters.stage}
            onChange={stageFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "챕터: 전체" },
              ...chapters.filter(
                (el) =>
                  tableParams.filters.stage === "all" ||
                  tableParams.filters.stage === el.stage_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.stage === "all"}
            defaultValue="all"
            value={tableParams.filters.chapter}
            onChange={chapterFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "유닛: 전체" },
              ...units.filter(
                (el) =>
                  tableParams.filters.chapter === "all" ||
                  tableParams.filters.chapter === el.chapter_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.chapter === "all"}
            defaultValue="all"
            value={tableParams.filters.unit}
            onChange={unitFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "서브유닛: 전체" },
              ...subUnits.filter(
                (el) =>
                  tableParams.filters.unit === "all" ||
                  tableParams.filters.unit === el.unit_code
              ),
            ]}
            style={{ width: 200, textAlign: "left" }}
            disabled={tableParams.filters.unit === "all"}
            defaultValue="all"
            value={tableParams.filters.subUnit}
            onChange={subUnitFilter}
          ></Select>
          <Select
            options={[
              { value: "all", label: "문장상태: 전체" },
              { value: "N", label: "운영" },
              { value: "Y", label: "편집" },
            ]}
            style={{ width: 150, textAlign: "left" }}
            defaultValue="all"
            value={tableParams.filters.sentenceStatus}
            onChange={sentenceStatusFilter}
          ></Select>
          <Input.Search
            placeholder="영어 문장을 입력하세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px",
            }}
          />
          <Button onClick={()=>setImageSetting(true)}>
            <SettingOutlined />설정
          </Button>
          <Button disabled={selectedKeys.length === 0} onClick={createMeaningPromptAll}>
            <PlusOutlined />의미 프롬프트 생성
          </Button>
          <Button disabled={selectedKeys.length === 0} onClick={createBackgroundPromptAll}>
            <PlusOutlined />배경 프롬프트 생성
          </Button>
          <Button disabled={selectedKeys.length === 0} onClick={createImageAll}>
            <PlusOutlined />이미지 생성
          </Button>
        </Space>
      </div>
      <div style={{ display: "flex", height:"90%", width:"100%", overflow: "auto" }}>
        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            className="pageTable"
            onRow={onRow}
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            rowSelection={{
              selectedRowKeys: selectedKeys,
              onChange: (keys, rows) => {
                setStartEnd([0, rows.length - 1]);
                setSelectedRows(rows.sort((a, b) => a.num - b.num));
                setSelectedKeys(keys.sort((a, b) => a - b));
              },
            }}
            columns={columns}
            rowKey="id"
            dataSource={sourceDataKor}
            loading={loading}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            footer={() => (
              <div style={{ textAlign: "left" }}>
                <Space>
                  <Button onClick={changeStatusAll}>
                    <EditFilled />
                    선택문장을 '운영'상태로 변경
                  </Button>
                  <Button onClick={deleteAll}>
                    <DeleteFilled/>
                     선택문장의 이미지 삭제
                  </Button>
                </Space>
              </div>
            )}
            scroll={{ x:100, y:"100%"}}
          />
        </Col>
        {rightBox[0] ? (
          <Spin spinning={rightBoxLoading}>
            <Col
              flex={0}
              style={{
                minWidth: "500px",
                border: "1px whitesmoke solid",
                margin: "0px 20px",
                height: "100%",
                display:"flex",
                flexDirection:"column",
              }}
            >
              <div
                style={{
                  padding: "10px",
                  borderBottom: "1px whitesmoke solid",
                  fontWeight: 700,
                  fontSize: 17,
                  textAlign: "left",
                }}
              >
                이미지 목록
              </div>
              <SentenceImageRight data={rightBox[1]} imageDeleteHandler={imageDeleteHandler} orderChangeHandler={orderChangeHandler} imageConfig={imageConfig} reRenderHandler={reRenderHandler} loadingHandler={loadingHandler}/>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderTop: "1px whitesmoke solid",
                }}
              >
                <span>
                  <Button
                    onClick={preRecordRight}
                    disabled={rightBoxPreNext[0] || loading}
                    icon={<LeftOutlined />}
                  >
                    이전
                  </Button>
                  <Button
                    style={{ marginLeft: "5px" }}
                    type="primary"
                    onClick={createImage}
                    icon={<CheckOutlined />}
                  >
                    생성
                  </Button>
                  <Button
                    style={{ marginLeft: "5px" }}
                    onClick={nextRecordRight}
                    disabled={rightBoxPreNext[1] || loading}
                    icon={<RightOutlined />}
                  >
                    다음
                  </Button>
                  <Button
                    style={{ marginLeft: "5px" }}
                    onClick={editCancelHandlerRight}
                    icon={<CloseOutlined />}
                  >
                    취소
                  </Button>
                </span>
              </div>
            </Col>
          </Spin>
        ) : null}
      </div>
      </Spin>
      </Spin>
    </div>
  );
}

export default SentenceInterpretation;
